import React from 'react';
import * as Yup from 'yup';
import {PASSWORD_REGEX} from "../../../data/settings";

export const MainUserPasswordValidatorSchema = Yup.object().shape({
    oldpassword: Yup.string()
        .min(2, 'tooShort')
        .max(50, 'tooLong')
        .matches(
            PASSWORD_REGEX,
            "passwordPolicy"
        )
        .required('required'),
    password: Yup.string()
        .min(2, 'tooShort')
        .max(50, 'tooLong')
        .matches(
            PASSWORD_REGEX,
            "passwordPolicy"
        )
        .required('required'),
    confirmpassword: Yup.string()
        .oneOf([Yup.ref('password'), null], 'passwordsMustMatch')
        .matches(
            PASSWORD_REGEX,
            "passwordPolicy"
        )
        .required('required')
});